<script>
import Vue from 'vue'

import Common from '../../../../common/Common.vue'
import Endpoints from '../../../../common/Endpoints.vue'
import Request from '../../../../common/Request.vue'
import Services from '../../../../common/Services.vue'
import moment from 'moment-timezone'

Vue.prototype.$registerEvent = new Vue()

export default {
    init: async payload => {
        await payload.initTable()
        if (!payload.isSuperAdminMaster) {
            payload.data.account = await Common.getAccountId(payload)
        }
    },
    methods: {
        buildUtcDateTime(date, hour) {
            const accountTimezone = Common.getAccountTimezone()
            return moment.tz(`${date} ${hour}`, 'YYYY-MM-DD HH:mm', accountTimezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        },
        isValidBeginDate(event) {
            const dateString = event?.target?.value

            if (dateString.length > 10) {
                this.data.beginDate = dateString.substring(0, 10)
            }

            if (dateString.length === 10) {
                this.data.beginDate = dateString
            }
        },
        isValidEndDate(event) {
            const dateString = event?.target?.value

            if (dateString.length > 10) {
                this.data.endDate = dateString.substring(0, 10)
            }

            if (dateString.length === 10) {
                this.data.endDate = dateString
            }
        },
        checkRequiredField(field) {
            return this.errors.includes(field)
        },
        removeRequiredField(field) {
            this.errors = this.errors.filter(item => item !== field)
        },
        createRoute: async function () {
            if (!this.data?.points) return

            this.$bvModal.show('createItineraryModal')
        },
        loadRoute: async function () {
            if (!this.data?.points) return

            this.$bvModal.show('itineraryListModal')
        },
        changeAccount: async function () {
            this.data.client = ''

            this.clearFields()

            const account = this.data.account
            this.clientList = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            this.clearFields()

            this.patrolPoints = await Services.getSupervisionCheckPointsByClient(this, this.data?.client)
            this.itineraries = await Services.getItinerariesByClient(this, this.data?.client)
        },
        // O payload sai de um clone: o template faz bind direto em nós aninhados
        // (`data.frequencyYear.month`), então remover nós do estado durante o save
        // derruba o render do modal na próxima vez que a frequência for usada.
        buildSchedulePayload() {
            const payload = { ...this.data }

            if (!payload.guardGroup) delete payload.guardGroup

            if (payload.frequency === 'DAILY' || payload.frequency === 'WEEKLY' || payload.frequency === 'NOT_REPEAT') {
                delete payload.frequencyYear
                delete payload.frequencyMonth
            }

            return payload
        },
        async update() {
            if (!this.isSaveLoading) {
                this.isSaveLoading = true
                try {
                    Request.do(
                        this,
                        'post',
                        Request.getDefaultHeader(this),
                        this.buildSchedulePayload(),
                        `${Endpoints.schedules.supervisoryUpdate}`,
                        async response => {
                            if (response.status === 200) {
                                this.isSaveLoading = false
                                this.$registerEvent.$emit('refreshSchedule')
                                Common.show(this, 'bottom-right', 'success', this.data._id ? this.$t('str.form.update.success') : this.$t('str.form.create.success'))
                                await this.closeModal()
                            }
                        },
                        () => {
                            this.isLoading = false
                            this.isSaveLoading = false
                            Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                        },
                    )
                } catch (_error) {
                    this.isLoading = false
                    this.isSaveLoading = false
                    Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                }
            }
        },
        async updateOccurrence() {
            if (!this.isSaveLoading) {
                this.isSaveLoading = true
                try {
                    Request.do(
                        this,
                        'post',
                        Request.getDefaultHeader(this),
                        this.buildSchedulePayload(),
                        `${Endpoints.appointments.supervisorUpdateOccurrence}`,
                        async response => {
                            if (response.status === 200) {
                                Common.show(this, 'bottom-right', 'success', this.data._id ? this.$t('str.form.update.success') : this.$t('str.form.create.success'))

                                this.isSaveLoading = false
                                this.$registerEvent.$emit('refreshSchedule')
                                await this.closeModal()
                            }
                        },
                        () => {
                            this.isLoading = false
                            this.isSaveLoading = false
                            Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                        },
                    )
                } catch (_error) {
                    this.isLoading = false
                    this.isSaveLoading = false
                    Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                }
            }
        },
        async save() {
            if (!this.isSaveLoading) {
                this.isSaveLoading = true

                try {
                    Request.do(
                        this,
                        this.data._id ? 'put' : 'post',
                        Request.getDefaultHeader(this),
                        this.buildSchedulePayload(),
                        `${Endpoints.schedules.supervisorySchedule}`,
                        async response => {
                            if (response.status === 200) {
                                this.isSaveLoading = false
                                this.$registerEvent.$emit('refreshSchedule')

                                Common.show(this, 'bottom-right', 'success', this.data._id ? this.$t('str.form.update.success') : this.$t('str.form.create.success'))
                                await this.closeModal()
                            }
                        },
                        () => {
                            this.isLoading = false
                            this.isSaveLoading = false
                            Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                        },
                    )
                } catch (_error) {
                    this.isLoading = false
                    this.isSaveLoading = false
                    Common.show(this, 'bottom-right', 'warn', this.data._id ? this.$t('str.form.update.generic.error') : this.$t('str.form.save.generic.error'))
                }
            }
        },
        async checkForm() {
            if (!this.data.account || this.data.account === '') {
                this.errors.push('account')
            }
            if (!this.data.client || this.data.client === '') {
                this.errors.push('client')
            }

            if (!this.data.beginDate || this.data.beginDate === '') {
                this.errors.push('beginDate')
            }
            if (!this.data.endDate || this.data.endDate === '') {
                this.errors.push('endDate')
            }
            if (!this.data.frequency || this.data.frequency === '') {
                this.errors.push('frequency')
            }
            if (!this.data.beginHour || this.data.beginHour === '') {
                this.errors.push('beginHour')
            }
            if (!this.data.endHour || this.data.endHour === '') {
                this.errors.push('endHour')
            }
            if (!this.data.points || this.data.points.length === 0) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.schedule.error.points.empty'))
                return
            }

            if (this.data?.frequency === 'YEARLY' && (!this.data?.frequencyYear?.month || this.data?.frequencyYear?.month === '')) {
                this.errors.push('frequencyYearMonth')
            }

            if (this.data?.frequency === 'YEARLY' && (!this.data?.frequencyYear?.day || this.data?.frequencyYear?.day === '')) {
                this.errors.push('frequencyYearDay')
            }

            if (this.data?.frequency === 'MONTHLY' && (!this.data?.frequencyMonth?.day || this.data?.frequencyMonth?.day === '')) {
                this.errors.push('frequencyMonthDay')
            }

            // verify errors and if end date is greater than begin date and if range is smaller than one year
            if (!this.errors || (this.errors.length === 0 && this.checkRangeDate())) {
                this.data.beginDate = this.buildUtcDateTime(this.data.beginDate, this.data.beginHour)
                this.data.endDate = this.buildUtcDateTime(this.data.endDate, this.data.endHour)

                if (!this.data.name || this.data.name === '') {
                    const client = this.clientList.find(client => client?._id === this.data.client)
                    if (client?.name) this.data.name = `${client.name}`
                }

                if (this.updateSchedule) {
                    await this.update()
                } else if (this.updateAppointment) {
                    await this.updateOccurrence()
                } else {
                    await this.save()
                }
            }
        },
        checkRangeDate: async function () {
            if (this.data.beginDate && this.data.endDate) {
                const beginDate = new Date(this.data.beginDate)
                const endDate = new Date(this.data.endDate)
                const diff = endDate.getTime() - beginDate.getTime()
                const diffDays = Math.ceil(diff / (1000 * 3600 * 24))
                if (diffDays < 0) {
                    // begin date is greater than end date
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.schedule.error.begin.date.greater.than.end.date'))
                    return false
                } else if (diffDays > 365) {
                    // range is greater than one year
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.schedule.error.range.greater.than.one.year'))
                    return false
                }
                return true
            }
            return false
        },
        confirmEdit: async function () {
            this.$swal({
                title: this.$t('str.are.you.sure'),
                text: this.$t('str.are.you.sure.edit.schedule'),
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: this.$t('str.title.edit.series'),
                cancelButtonClass: 'btn btn-default min-btn-width',
                denyButtonText: this.$t('str.title.edit.occurrence'),
                confirmButtonClass: 'btn me-5px btn-danger min-btn-width',
                cancelButtonText: this.$t('str.btn.exit'),
                denyButtonClass: 'btn me-5px btn-warning min-btn-width',
            }).then(result => {
                if (result.isConfirmed) {
                    this.updateAppointmentSeries()
                } else if (result.isDenied) {
                    this.updateAppointmentOccurrence()
                }
            })
        },
        updateAppointmentSeries: async function () {
            const newData = JSON.parse(JSON.stringify({ ...this.data, ...this.seriesDetails }))
            const accountTimezone = Common.getAccountTimezone()
            newData.schedule = newData._id
            delete newData._id

            this.patrolPoints = await Services.getSupervisionCheckPointsByClient(this, this.data?.client)
            this.itineraries = await Services.getItinerariesByClient(this, this.data?.client)

            if (!this.isPastDate) {
                newData.beginDate = moment.tz(this.data?.appointment?.startDate, accountTimezone).format('YYYY-MM-DD')
            }

            this.data = newData
            this.updateSchedule = true
        },
        updateAppointmentOccurrence: async function () {
            const newData = JSON.parse(JSON.stringify(this.data))
            const accountTimezone = Common.getAccountTimezone()
            newData.schedule = this.data._id

            delete newData._id

            this.patrolPoints = await Services.getSupervisionCheckPointsByClient(this, this.data?.client)
            this.itineraries = await Services.getItinerariesByClient(this, this.data?.client)

            newData.beginDate = moment.tz(this.data?.appointment?.startDate, accountTimezone).format('YYYY-MM-DD')
            newData.endDate = moment.tz(this.data?.appointment?.endDate, accountTimezone).format('YYYY-MM-DD')

            newData.beginHour = this.data?.appointment?.startHour
            newData.endHour = this.data?.appointment?.endHour
            newData.timeSlot = this.data?.appointment?.timeSlot

            newData.points = this.resolvePointRows(this.data?.appointment?.patrolPoints || [], newData.points)

            this.data = newData
            this.updateAppointment = true
        },
        resolvePointRows(points, sourcePoints = []) {
            const availablePoints = [...sourcePoints, ...this.patrolPoints]
            return points.map(point => {
                if (point && typeof point === 'object') return { ...point }
                const details = availablePoints.find(item => item && typeof item === 'object' && String(item._id) === String(point))
                return details ? { ...details } : { _id: point, name: String(point) }
            })
        },
        confirmArchive() {
            this.$swal({
                title: this.$t('str.are.you.sure'),
                text: this.$t('str.are.you.sure.delete.schedule'),
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: this.$t('str.title.delete.series'),
                cancelButtonClass: 'btn btn-default min-btn-width',
                denyButtonText: this.$t('str.title.delete.occurrence'),
                confirmButtonClass: 'btn me-5px btn-danger min-btn-width',
                cancelButtonText: this.$t('str.btn.exit'),
                denyButtonClass: 'btn me-5px btn-warning min-btn-width',
            }).then(result => {
                if (result.isConfirmed) {
                    this.cancelAppointmentSeries()
                } else if (result.isDenied) {
                    this.cancelAppointmentOccurrence()
                }
            })
        },
        cancelAppointmentSeries: async function () {
            const filters = {
                schedule: this.data._id,
                startDate: moment().utc().format(),
            }
            this.isLoading = true

            try {
                const cancelled = await Services.cancelAppointmentSeries(this, filters)
                if (!cancelled) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                    return false
                }

                this.$registerEvent.$emit('cancelAppointment')
                return true
            } catch (_error) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                return false
            } finally {
                this.isLoading = false
            }
        },
        cancelAppointmentOccurrence: async function () {
            const filters = {
                appointment: this.data.appointment,
            }
            this.isLoading = true

            try {
                const cancelled = await Services.cancelAppointmentOccurrence(this, filters)
                if (!cancelled) {
                    Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                    return false
                }

                this.$registerEvent.$emit('cancelAppointment')
                return true
            } catch (_error) {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                return false
            } finally {
                this.isLoading = false
            }
        },
        selectItineraryRow(row) {
            this.selectedItinerary = row // Define a linha selecionada
        },
        clearItinerarySelection() {
            this.selectedItinerary = null // Limpa a seleção da linha
        },
        updateSelectedItinerary(selectedRow) {
            this.selectedItinerary = selectedRow // Atualiza a linha selecionada na primeira modal
            this.data.points = selectedRow?.patrolPoints // Atualiza os pontos do itinerário na segunda modal
        },
        clearCheckPoints() {
            this.data.points = [] // Limpa a lista de pontos
        },
        changeFrequency: function () {
            this.data.frequencyYear = {
                month: '',
                day: '',
            }
            this.data.frequencyMonth = {
                day: '',
            }
            this.data.weeklyDays = []
            this.removeRequiredField('frequencyMonthDay')
            this.removeRequiredField('frequencyYearMonth')
            this.removeRequiredField('frequencyYearDay')
        },

        async selectAllPatrolPoints() {
            // Copia todos os patrol points disponíveis (ignora paginação)
            this.selectedPatrolPoints = [...this.patrolPoints]
            this.data.points = [...this.patrolPoints]
            this.removeRequiredField('points')
        },

        // Remove todos os patrol points selecionados
        async removeAllPatrolPoints() {
            this.selectedPatrolPoints = []
            this.data.points = []
            this.removeRequiredField('points')
        },

        async closeModal() {
            this.data = {
                name: '',
                guardGroup: '',
                account: '',
                client: '',
                frequency: '',
                category: '',
                frequencyMonth: {
                    day: '',
                },
                frequencyYear: {
                    month: '',
                    day: '',
                },
                points: [],
                vigilants: [],
                weeklyDays: [],
                beginDate: moment().utc().format('YYYY-MM-DD'),
                endDate: null,
                beginHour: '',
                endHour: '',
                sendAlert: false,
                notifyVigilants: true,
                timeSlot: 15,
                type: 'FREE-PROGRAM',
                status: 'ACTIVE',
            }

            this.patrolPoints = []
            this.errors = []

            // if (!this.isSuperAdminMaster) {
            //     this.data.account = await Common.getAccountId(this)
            //     this.accountList = []
            // } else {
            //     this.clientList = []
            // }

            this.isPastDate = false
            this.updateSchedule = false
            this.updateAppointment = false

            this.$bvModal.hide('createScheduleModal')
        },
        clearFields() {
            this.data.points = []
            this.patrolPoints = []
        },
        verifyDay: function () {
            // check if day of month is valid for selected month
            const month = this.data?.frequencyYear?.month
            const day = this.data?.frequencyYear?.day

            if (month && day) {
                const daysInMonth = new Date(new Date().getFullYear(), month, 0).getDate()
                if (day > daysInMonth) {
                    this.data.frequencyYear.day = daysInMonth
                }
            }
        },
        verifyMonthDay: function () {
            // check if day of month is valid for selected month
            const day = this.data?.frequencyMonth?.day
            if (day > 31) {
                this.data.frequencyMonth.day = 31
            }
        },
        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.check.point.column.actions'),
                    field: 'actions',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.name'),
                    field: 'name',
                    width: '20%',
                    sortable: true,
                    firstSortType: 'desc',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.type'),
                    field: 'type',
                    width: '10%',
                    sortable: true,
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.geolocation'),
                    field: 'geolocation',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.radius'),
                    field: 'radius',
                    width: '5%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },

                {
                    label: this.$t('str.table.check.point.column.note'),
                    field: 'notes',
                    width: '25%',
                    sortable: true,
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
            ]
        },
        showMap() {
            this.$bvModal.show('mapModal')
        },
        selectItem(item) {
            this.patrolPointItem = item
        },
        removeRow(row) {
            if (this.updateAppointment || this.updateSchedule || !this.data._id) {
                const index = row?.originalIndex

                if (index !== -1) {
                    this.data.points.splice(index, 1)
                }
            }
        },
        clearList() {
            this.data.points = [] // Limpa a lista de pontos
        },
        addPatrolPoints() {
            for (const selectedPoint of this.selectedPatrolPoints) {
                if (!this.data.points.some(point => point === selectedPoint)) {
                    this.data.points.push(selectedPoint)
                }
            }
            this.selectedPatrolPoints = [] // Limpar seleção após adicionar
        },
        async initSelectedAppointment() {
            this.isLoading = true

            try {
                const accountTimezone = Common.getAccountTimezone()
                this.data.account = this.data?.account?._id || this.data.account
                this.data.client = this.data?.client?._id || this.data.client
                const source = this.selectedAppointment || this.data
                this.seriesDetails = JSON.parse(JSON.stringify({
                    beginDate: String(source.beginDate || '').slice(0, 10),
                    endDate: String(source.endDate || '').slice(0, 10),
                    beginHour: source.beginHour,
                    endHour: source.endHour,
                    points: source.points || [],
                }))
                this.appointment = this.data?.appointment

                // Source dates are civil dates; only appointment instants need timezone conversion.
                this.data.beginDate = String(this.data?.beginDate || '').slice(0, 10)
                this.data.endDate = String(this.data?.endDate || '').slice(0, 10)

                const start = this.appointment?.start || this.appointment?.startDate
                const end = this.appointment?.end || this.appointment?.endDate
                if (start) {
                    this.data.beginDate = moment.tz(start, accountTimezone).format('YYYY-MM-DD')
                    this.data.beginHour = moment.tz(start, accountTimezone).format('HH:mm')
                }
                if (end) {
                    this.data.endDate = moment.tz(end, accountTimezone).format('YYYY-MM-DD')
                    this.data.endHour = moment.tz(end, accountTimezone).format('HH:mm')
                }

                this.isPastDate = moment.tz(this.appointment?.startDate, accountTimezone).isBefore(moment.tz(accountTimezone).startOf('day'))

                if (Common.isSuperAdminMaster(this)) {
                    this.accountList = await Services.getAccounts(this)
                }

                this.clientList = await Services.getClientsByAccount(this, this.data.account)
                this.patrolPoints = await Services.getSupervisionCheckPointsByClient(this, this.data.client)
                this.data.points = this.resolvePointRows(this.appointment?.patrolPoints ?? this.data.points ?? [], this.seriesDetails.points)

                if (this.data.points.length > 0) {
                    this.patrolPoints.forEach(patrolPoint => {
                        this.data.points.forEach(point => {
                            if (patrolPoint._id === point._id) {
                                this.$set(patrolPoint, 'vgtSelected', true)
                            }
                        })
                    })
                }

                this.isLoading = false
            } catch {
                this.isLoading = false
            }
        },
    },
    checkEnableInput: function () {
        return this.data._id ? true : false
    },
}
</script>
